/**
 * Resource FAQs — accordion for expandable style
 */
(() => {
  'use strict';

  function setOpen(item, open) {
    const answer = item.querySelector('.collapsible-content__answer');
    const toggle = item.querySelector('.faq-item__toggle');
    item.classList.toggle('active', open);
    if (answer) answer.style.display = open ? 'block' : 'none';
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function init(scope) {
    const roots = (scope || document).querySelectorAll('[data-resources-faqs]');
    roots.forEach((root) => {
      if (root.getAttribute('data-resources-faqs-ready') === 'true') return;
      if (root.getAttribute('data-style') !== 'expandable') return;

      root.setAttribute('data-resources-faqs-ready', 'true');
      const items = Array.from(root.querySelectorAll('.faq-item'));

      items.forEach((item) => {
        const btn = item.querySelector('.faq-item__toggle');
        if (!btn) return;

        btn.addEventListener('click', (event) => {
          event.preventDefault();
          const isOpen = item.classList.contains('active');
          items.forEach((other) => setOpen(other, false));
          if (!isOpen) setOpen(item, true);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target && event.target.querySelector('[data-resources-faqs]')) {
      init(event.target);
    }
  });
})();
